<template>
<div class="ew-page">
  <navbar-dashboard name="Métodos de pago"></navbar-dashboard>

  <div class="ew-page__body">
    <section class="ew-card">
      <div class="ew-empty">
        <ph-icon name="credit-card" />
        <p class="ew-empty__title">Próximamente</p>
        <p class="ew-empty__text">La administración de métodos de pago guardados estará disponible aquí pronto.</p>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import commons from '../commons'
import PhIcon from './icons/PhIcon'


export default {
  name: 'Payments',
  data () {
    return {

    }
  },
  created () {
    this.setItemActive('payments')

  },
  mounted(){

  },
  beforeDestroy(){

  },
  methods: {
   ...mapMutations(['setItemActive'])
  },
  computed: {
   ...mapGetters(['itemActive'])
  },
  components: {
    'navbar-dashboard': Navbar,
    PhIcon
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }
.ew-card { @include ew-card; }
.ew-empty { @include ew-empty; padding: 4rem 1rem; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }
</style>



// WEBPACK FOOTER //
// src/components/Payments.vue